export default "__VITE_ASSET__VLb_vfF$__"